import { create } from "zustand";

export const useSettingsStore = create((set) => ({
  ticketService: 0,
  confectioneryService: 0,
  maxSeats: 0,
  membershipValue: 0,
  membershipService: 0,
  epaycoBanks: [],

  setTicketService: (ticketService) => set({ ticketService }),
  setConfectioneryService: (confectioneryService) =>
    set({ confectioneryService }),
  setMaxSeats: (maxSeats) => set({ maxSeats }),
  setEpaycoBanks: (epaycoBanks) => set({ epaycoBanks }),
  setMembershipValue: (membershipValue) => set({ membershipValue }),
  setMembershipService: (membershipService) => set({ membershipService }),
}));
